/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection06FoiChanged, m11ReportSection06ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection06Foi, selectM11ReportSection06Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveTrialInterventionChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section06State, setAlertModalState, setStartingSection06State) => {

    let changesStates = {
        section06State: section06State
    };
    let response = await saveM11Changes(apiToken, 24, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection06Resource) {
            dispatch(m11ReportSection06ResourceChanged(response.m11ReportSection06Resource));
        }
        setStartingSection06State(JSON.parse(JSON.stringify(section06State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step024TrialInterventionPart4 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection06Foi = useSelector(selectM11ReportSection06Foi);
    const m11ReportSection06Resource = useSelector(selectM11ReportSection06Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section06State, setSection06State] = useState({
        "section671Status": "empty", "section671Xhtml": "",
        "section672Status": "empty", "section672Xhtml": "",
        "section673Status": "empty", "section673Xhtml": "",
        "section674Status": "empty", "section674Xhtml": ""
    });
    const [startingSection06State, setStartingSection06State] = useState({
        "section671Status": "empty", "section671Xhtml": "",
        "section672Status": "empty", "section672Xhtml": "",
        "section673Status": "empty", "section673Xhtml": "",
        "section674Status": "empty", "section674Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section06State, startingSection06State)),
        async saveAllChanges() {
            await saveTrialInterventionChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section06State, setAlertModalState, setStartingSection06State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section671Status": "empty", "section671Xhtml": "",
                "section672Status": "empty", "section672Xhtml": "",
                "section673Status": "empty", "section673Xhtml": "",
                "section674Status": "empty", "section674Xhtml": "",
                "loaded": true
            };
            setSection06State(startingData);
            setStartingSection06State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[6]?.entry?.length) {
                let m11ReportSection006Foi = getIdFromReference(m11ReportContainerResource.section[6].entry[0]);
                if (m11ReportSection006Foi && !isNaN(m11ReportSection006Foi) && m11ReportSection006Foi !== m11ReportSection06Foi) {
                    dispatch(m11ReportSection06FoiChanged(m11ReportSection006Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection06Foi && !isNaN(m11ReportSection06Foi)) {
            loadResource(m11ReportSection06Foi, "M11ReportSection06", apiToken, dispatch);
        }
    }, [m11ReportSection06Foi]);

    useEffect(() => {
        if (m11ReportSection06Resource && Object.keys(m11ReportSection06Resource).length > 0) {
            let startingData = {
                "section671Status": "empty", "section671Xhtml": "",
                "section672Status": "empty", "section672Xhtml": "",
                "section673Status": "empty", "section673Xhtml": "",
                "section674Status": "empty", "section674Xhtml": "",
                "loaded": true
            };
            if (m11ReportSection06Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection06Resource.section[0].section[6]?.section?.length > 0) {
                    if (m11ReportSection06Resource.section[0].section[6].section[0]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[6].section[0].text.status !== "empty") {
                        startingData.section671Status = m11ReportSection06Resource.section[0].section[6].section[0].text.status;
                        startingData.section671Xhtml = m11ReportSection06Resource.section[0].section[6].section[0].text.div;
                    }
                    if (m11ReportSection06Resource.section[0].section[6].section?.[1]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[6].section[1].text.status !== "empty") {
                        startingData.section672Status = m11ReportSection06Resource.section[0].section[6].section[1].text.status;
                        startingData.section672Xhtml = m11ReportSection06Resource.section[0].section[6].section[1].text.div;
                    }
                    if (m11ReportSection06Resource.section[0].section[6].section?.[2]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[6].section[2].text.status !== "empty") {
                        startingData.section673Status = m11ReportSection06Resource.section[0].section[6].section[2].text.status;
                        startingData.section673Xhtml = m11ReportSection06Resource.section[0].section[6].section[2].text.div;
                    }
                    if (m11ReportSection06Resource.section[0].section[6].section[3]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[6].section[3].text.status !== "empty") {
                        startingData.section674Status = m11ReportSection06Resource.section[0].section[6].section[3].text.status;
                        startingData.section674Xhtml = m11ReportSection06Resource.section[0].section[6].section[3].text.div;
                    }
                }
                setSection06State(startingData);
                setStartingSection06State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection06Resource]);

    return <div>
        <h3>Complete Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding</h3>
        {!(m11ReportSection06Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 24 (Complete Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>
                {section06State.loaded && <>
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.7.1 Participant Assignment to Investigational Trial Intervention.</h4>
                    <TextDivEntry elementName="section671Xhtml"
                        startingValue={section06State.section671Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>If applicable, enter data for Section 6.7.2 Randomisation.</h4>
                    <TextDivEntry elementName="section672Xhtml"
                        startingValue={section06State.section672Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>If applicable, enter data for Section 6.7.3 Measures to Maintain Blinding.</h4>
                    <TextDivEntry elementName="section673Xhtml"
                        startingValue={section06State.section673Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>If applicable, enter data for Section 6.7.4 Emergency Unblinding at the Site.</h4>
                    <TextDivEntry elementName="section674Xhtml"
                        startingValue={section06State.section674Xhtml}
                        setResourceState={setSection06State} />
                </>}
            </>
        }
    </div >
});

const M11Step024TrialInterventionPart4HelperText = <div>
    <h3>Complete Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 6.7.1 Participant Assignment to Investigational Trial Intervention.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>State that at enrollment, participant identification codes should be assigned. Describe the method of assigning participants to investigational trial intervention without being so specific that blinding or randomisation might be compromised. If assignment to investigational trial intervention is by randomisation, describe when randomisation will occur relative to screening.</p>
            <p>If permuted block randomisation is employed, do not state the block size in the protocol. If adaptive randomisation or other methods of covariate balancing/minimisation are employed, include a cross reference to the methods of analysis in Section 10 Statistical Considerations. As applicable, details regarding the implementation of procedures to minimise bias should be described.</p>
        </div>
        <p>If applicable, enter data for Section 6.7.2 Randomisation.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the randomisation procedures (e.g., central randomisation procedures), the method used to generate the randomisation schedule (e.g., computer generated), the source of the randomisation schedule (e.g., sponsor, investigator, or other), and whether IRT(s) will be used.</p>
            <p>To maintain the integrity of the blinding, do not include the block size.</p>
        </div>
        <p>If applicable, enter data for Section 6.7.3 Measures to Maintain Blinding.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe measures that will be used to maintain blinding:</p>
            <div style={{ marginLeft: "24px" }} >
                <p>The investigational trial interventions are as indistinguishable as possible</p>
                <p>Plans for the maintenance of randomisation codes and appropriate blinding for the trial</p>
                <p>Procedures for planned (e.g., interim analysis) and unintentional (e.g., breach of procedure) breaking of randomisation codes</p>
            </div>
            <p>For unplanned but intentional actions (e.g., safety events), refer to Section 6.7.4 Emergency Unblinding at the Site.</p>
            <p>If the trial allows for some investigators or other designated staff to remain unblinded (e.g., to allow them to adjust investigational trial intervention), the means of maintaining the blinding for other investigators or staff should be explained. Measures to prevent unblinding by laboratory measurements or while performing study assessments, if used, should be described.</p>
        </div>
        <p>If applicable, enter data for Section 6.7.4 Emergency Unblinding at the Site.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the criteria for breaking the trial blind or participant code. Describe the circumstances that would require breaking the blind, either for an individual participant or for all participants, and specify who will be responsible for this decision. Include the procedure for emergency unblinding as well as documentation of unblinding. Indicate to whom the intentional and unplanned unblinding should be reported.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step024TrialInterventionPart4ValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 24, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 24 (Complete Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding) {validationCheckState.step24numberOfChecks} issues checked. {validationCheckState.step24numberPassed} passed. {validationCheckState.step24numberFailed} failed.</h4>
        <p>Section 6.7 heading is 'Investigational Trial Intervention Assignment, Randomisation and Blinding': {validationCheckState.resultCheckSection67Heading}</p>
        <p>Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding does not have text: {validationCheckState.resultCheckSection67Text}</p>
        <p>Section 6.7.1 heading is 'Participant Assignment to Investigational Trial Intervention': {validationCheckState.resultCheckSection671Heading}</p>
        <p>Section 6.7.1 Participant Assignment to Investigational Trial Intervention has content: {validationCheckState.resultCheckSection671Content}</p>
        <p>If present, Section 6.7.2 heading is 'Randomisation': {validationCheckState.resultCheckSection672Heading}</p>
        <p>If present, Section 6.7.2 Randomisation has content: {validationCheckState.resultCheckSection672Content}</p>
        <p>If present, Section 6.7.3 heading is 'Measures to Maintain Blinding': {validationCheckState.resultCheckSection673Heading}</p>
        <p>If present, Section 6.7.3 Measures to Maintain Blinding has content: {validationCheckState.resultCheckSection673Content}</p>
        <p>If present, Section 6.7.4 heading is 'Emergency Unblinding at the Site': {validationCheckState.resultCheckSection674Heading}</p>
        <p>If present, Section 6.7.4 Emergency Unblinding at the Site has content: {validationCheckState.resultCheckSection674Content}</p>
    </div>}  </div>
}

export default M11Step024TrialInterventionPart4;
export { M11Step024TrialInterventionPart4HelperText, M11Step024TrialInterventionPart4ValidationCheck };